
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";
import { 
  Select, 
  SelectContent, 
  SelectItem, 
  SelectTrigger, 
  SelectValue 
} from "@/components/ui/select";

interface SleepStepProps {
  formData: {
    averageSleep: string;
    sleepQuality: string;
    sleepIssues: string[];
  };
  handleSelectChange: (name: string, value: string) => void;
  handleCheckboxChange: (list: string, value: string) => void;
}

export function SleepStep({ 
  formData, 
  handleSelectChange, 
  handleCheckboxChange 
}: SleepStepProps) {
  return (
    <div className="space-y-4">
      <div>
        <Label htmlFor="averageSleep">Average Sleep Duration (hours)</Label>
        <Select 
          onValueChange={(value) => handleSelectChange("averageSleep", value)}
          value={formData.averageSleep}
        >
          <SelectTrigger>
            <SelectValue placeholder="Select average sleep hours" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="less-than-5">Less than 5 hours</SelectItem>
            <SelectItem value="5-6">5-6 hours</SelectItem>
            <SelectItem value="7-8">7-8 hours</SelectItem>
            <SelectItem value="9+">9+ hours</SelectItem>
          </SelectContent>
        </Select>
      </div>

      <div>
        <Label htmlFor="sleepQuality">Sleep Quality</Label>
        <Select 
          onValueChange={(value) => handleSelectChange("sleepQuality", value)}
          value={formData.sleepQuality}
        >
          <SelectTrigger>
            <SelectValue placeholder="Rate your sleep quality" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="poor">Poor</SelectItem>
            <SelectItem value="fair">Fair</SelectItem>
            <SelectItem value="good">Good</SelectItem>
            <SelectItem value="excellent">Excellent</SelectItem>
          </SelectContent>
        </Select>
      </div>

      <div>
        <Label>Sleep Issues</Label>
        <div className="space-y-2 mt-2">
          {["falling-asleep", "staying-asleep", "early-waking", "snoring", "sleep-apnea", "restless-sleep", "none"].map((issue) => (
            <div key={issue} className="flex items-center space-x-2">
              <Checkbox
                id={issue}
                checked={(formData.sleepIssues as string[]).includes(issue)}
                onCheckedChange={() => handleCheckboxChange("sleepIssues", issue)}
              />
              <Label htmlFor={issue}>
                {issue === "none" 
                  ? "No sleep issues" 
                  : issue.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}
              </Label>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
